import { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import ClientsListPage, { type Tenant } from './ClientsListPage';
import ClientDetailPage from './ClientDetailPage';
import DevicesPage from '../components/Admin/DevicesPage';
import MqttLogsPage from './MqttLogsPage';
import SettingsPage from '../components/Settings/SettingsPage';
import { SettingsProvider } from '../context/SettingsContext';

interface Props {
  user: any;
  onLogout: () => void;
  onThemeToggle: () => void;
  isDark: boolean;
  onUserUpdated: (patch: { name: string | null }) => void;
}

export default function AdminApp({ user, onLogout, onThemeToggle, isDark, onUserUpdated }: Props) {
  const [currentPage, setCurrentPage] = useState<'clients' | 'devices' | 'mqttLogs' | 'settings'>('clients');
  const [selectedTenant, setSelectedTenant] = useState<Tenant | null>(null);

  return (
    // SettingsProvider: SettingsPage > Preferences usa useSettings() (unidades,
    // formato de fecha, timezone) — sin el provider, ese hook lanza y tira
    // toda la consola a blanco (React no tiene error boundary acá).
    <SettingsProvider>
    <div className="app">
      <AdminSidebar
        currentPage={currentPage}
        onNavigate={(page) => { setSelectedTenant(null); setCurrentPage(page); }}
        user={user}
        onLogout={onLogout}
        onThemeToggle={onThemeToggle}
        isDark={isDark}
      />
      <div className="content">
        {currentPage === 'clients' && (
          selectedTenant
            ? (
              <ClientDetailPage
                tenant={selectedTenant}
                onBack={() => setSelectedTenant(null)}
                onTenantUpdated={setSelectedTenant}
              />
            )
            : <ClientsListPage onSelect={setSelectedTenant} />
        )}
        {currentPage === 'devices' && <DevicesPage />}
        {currentPage === 'mqttLogs' && <MqttLogsPage />}
        {currentPage === 'settings' && (
          <SettingsPage user={user} onThemeToggle={onThemeToggle} isDark={isDark} onUserUpdated={onUserUpdated} />
        )}
      </div>
    </div>
    </SettingsProvider>
  );
}
